module.exports = __webpack_public_path__ + "04_glasses_red.bdc4e27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/04_glasses_red.png
// module id = DTB5
// module chunks = 0